let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("b1uNO")).then(() => parcelRequire('JXA9h'));